import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import {
  DESKTOP_EXTRA_SMALL_WIDTH,
  DESKTOP_WIDTH,
  MOBILE_WIDTH,
  TABLET_WIDTH,
} from 'Styles/variables/sizes';

export const Container = styled.section`
  display: grid;
  grid-template-columns: ${pxToRem(325)} 2fr ${pxToRem(325)};
  grid-column-gap: ${pxToRem(30)};
  padding: ${pxToRem(30)};
  height: 100%;
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    grid-template-columns: minmax(${pxToRem(10)}, ${pxToRem(325)}) 2fr;
    > aside {
      display: none;
    }
  }
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    > aside {
      min-width: 0;
      max-width: 0;
      margin: 0;
    }
  }
  @media screen and (max-width: ${TABLET_WIDTH}) {
    grid-template-columns: 100% 2fr;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${pxToRem(20)};
  }
`;
